var animatePlx = {};

(function ( $ ) {

    var speedTimes = 0.2;

    animatePlx.speedTimes = function() {
        if ( Viewport.documentWidth().width < 768 ) {
            // speedTimes = 0.05;
            speedTimes = 0.1;
        }
        else if ( Viewport.documentWidth().width < 1800 ) {
            speedTimes = 0.2;
        }
        else {
            speedTimes = 0.05;
        }
    };

    animatePlx.iosDetect = function() {
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        if(!iOS)  {
            $('.js-delay-image').addClass('has-trans');
        }
    };

    animatePlx.speedTimes();
    animatePlx.iosDetect();

    animatePlx.scrollFunc = function (parentClass, childrenClass, windowThis) {

        if ( $( parentClass ).length ) {
            var top_header = $(parentClass);
            top_header.children(childrenClass).css({'background-position':'center center'});

            var heightSubtract =  top_header.height() + 60;
            // if(top_header.offset().top === 0) {
            //     heightSubtract =  0;
            // }

            var st = windowThis.scrollTop() - (top_header.offset().top - heightSubtract);
            top_header.children(childrenClass).css({'background-position' : 'center calc(50% - ' + ( st * speedTimes ) + 'px)'});
        }
    };

    var mTop = $(".hero-banner .info .h1").css("margin-top");
    var mTopParse = parseInt(mTop, 10);

    animatePlx.bannerContentHide = function() {
        if ( $( ".hero-banner" ).length ) {
            $(".hero-banner .info .h1").css("opacity", 1 - $(window).scrollTop() / ( $('.hero-banner').outerHeight() / 2));
            $(".hero-banner .info .h1").css("margin-top", mTopParse - ( $(window).scrollTop() / $('.hero-banner').outerHeight() * 1000 ));
        }
    };

    var transposed = "desktop";

    animatePlx.bgChange = function() {
        $('.js-parallax').each(function() {
            if ( Viewport.documentWidth().width < 768 ) {
                transposed = "mobile";
                var mobileImage = $(this).data('imageMobile');
                $(this).data('imageSrc', mobileImage);
            } else {
                transposed = "desktop";
                var desktopImage = $(this).data('imageDesktop');
                $(this).data('imageSrc', desktopImage);
            }
        });
    };

    animatePlx.parallaxBG = function() {
        $('.js-parallax').parallax({
            naturalWidth: 1920,
            naturalheight: 1068,
            speed: 0.2,
            position: 'top',
            iosFix: true,
            androidFix: true,
            overScrollFix: true,
        });
    };

    animatePlx.parallaxBG = function() {

        $('.js-parallax').parallax({
            naturalWidth: 1920,
            naturalheight: 1068,
            speed: 0.2,
            position: 'top',
            iosFix: true,
            androidFix: true,
            overScrollFix: true,
        });
    };

    animatePlx.parallaxBGmobile = function(Desktop) {
        
        $('.js-parallax').parallax({
            naturalWidth: 767,
            naturalheight: 1197,
            speed: 0.2,
            position: 'top',
            iosFix: true,
            androidFix: true,
            overScrollFix: true,
        });
    };

    animatePlx.transPosed =  function() {
        if ( Viewport.documentWidth().width < 768 && transposed !== "mobile") {
            transposed = "mobile";
            $('.js-parallax').parallax('destroy');
            animatePlx.bgChange();
            animatePlx.parallaxBGmobile();
        }

        if ( Viewport.documentWidth().width > 768 && transposed !== "desktop") {
            transposed = "desktop";
            $('.js-parallax').parallax('destroy');
            animatePlx.bgChange();
            animatePlx.parallaxBG();
        }
    };



    // parallax.js 
    // animatePlx.bgChange();
    // animatePlx.parallaxBG();
    
    $( window ).scroll( function () {
        animatePlx.scrollFunc('.hero-banner', '.js-delay-image', $(this) );
        animatePlx.scrollFunc('.cover-block', '.js-delay-image', $(this) );
        animatePlx.bannerContentHide();
    } ).scroll();


    $( window ).on( 'resize', function(){ 
        animatePlx.speedTimes();
        animatePlx.iosDetect();
       
        // parallax.js
        // animatePlx.transPosed();
    });
    
    // parallax.js
    // $(window).trigger('resize').trigger('scroll');


})( jQuery );
